import React from "react";
import * as svg from "../assets/icons.js";

const Icon = function (props) {
  const SvgIcon = svg[props.iconName];

  // Check if SvgIcon exists before rendering
  if (!SvgIcon) {
    console.warn(`Icon "${props.iconName}" not found`);
    return null; // Or return a fallback icon
  }

  const { height, width, ...rest } = props;

  return (
    <SvgIcon {...rest} color={props.color} width={width} height={height} />
  );
};

export default Icon;